import React from 'react';
import styled, { css } from 'styled-components';
import Paragraph from '../../collections/Paragraph/Paragraph';
import { media } from '../../utilities/style-utilities';
import { fontUbuntu, fontUbuntuLight } from '../../utilities/utilities';
// import { remy } from '../../utilities/utilities';

const ContentInner = styled.div`
  display: flex;
  flex-direction: ${props => props.column ? 'column' : 'row'};
  align-items:center;
`;

const ContentInnerColumn = styled.div`
  display: flex;
  flex-direction: ${props => props.column ? 'column-reverse' : 'row'};
  width:100%;
`;

const ContentColLeft = styled.div`
  flex: 1 1 50%;
  -webkit-flex: 1 1 auto; /* Safari 6.1+ */
  -ms-flex: 1 1 auto; /* IE 11- */
  display: flex;
  display: -ms-flexbox;
  flex-direction: column;
  align-items: center;
  width:100%;
`;

const ContentColRight = styled.div`
  flex: 1 1 44%;
  -webkit-flex: 1 1 auto; /* Safari 6.1+ */
  -ms-flex: 1 1 auto; /* IE 11- */
  display: flex;
  display: -ms-flexbox;
  display: -ms-flexbox;
  flex-direction: column;
  align-items: center;
  width:100%;
  overflow:hidden;
`;
const Header1 = styled(Paragraph)`
font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
text-align: left;
font-size: 2em;
max-width: ${ props => props.maxWidth};
font-weight: ${ props => props.fontWeight};
margin:0;
`
const Header2 = styled(Paragraph)`
font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
text-align: left;
font-size: 1.2em;
max-width: ${ props => props.maxWidth};
font-weight: ${ props => props.fontWeight};
margin:0;
`
const ContentParagraph = styled(Paragraph)`
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
  text-align: center;
  font-size: 1.05em;
  max-width: ${ props => props.maxWidth};
  font-weight: ${ props => props.fontWeight};
  margin-bottom: ${ props => props.marginBottom};

  ${ props => props.margin && css`
    line-height: 1.4rem;
    margin: 1.4rem 0;
  `} 
`;

const AmountBox = styled.div`
  display: flex;
  justify-content: center;
  background-color: #f7f7f7;
  border: 1px solid #e6e6e6;
  padding: 0.75rem 1rem 0.75rem 1rem;
  max-width: 290px;
  width:100%;
  margin: 0 auto;
`;

const Amount = styled.span`
  font-size: 3em;
  color: #0d1b58;
  font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntu};
  background-color: #ffffff;
  border: 1px solid #e6e6e6;
  padding: 0.2rem;
  flex: 1 1 auto;
  text-align: center;
`

const Retailers = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  /* background-color: gray; */
  margin: 0 1rem;
  max-width: 100%;
  width:100%;
  padding-bottom: 1.5rem;
  /* ${ media.desktop`
    max-width: 500px;
  `} */
`;

const Offers = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;

const TwoColumnWrapper = styled.div`
display:flex;
flex-direction:row;
${ media.tablet`
flex-direction: column;
`}
flex-wrap: wrap;
width:100%;
overflow:hidden;
`;

const SingleColumn = styled.div`
display:flex;
flex-direction:column;
flex-grow:1;
width:50%;
${ media.tablet`
width:auto;
max-width:400px;
padding:0 15px;
margin:auto;
width:100%;
`}
`;

// const LeftPaddingDiv = styled.div`
//   padding-left:15px;
// `;

const RightPaddingDiv = styled.div`
  padding-right:15px;
`;

const TextWrapperDiv = styled.div`
font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
text-align: left;
font-size: 0.7em;
max-width: ${ props => props.maxWidth};
font-weight: ${ props => props.fontWeight};
margin-bottom: ${ props => props.marginBottom};
width:40%;
padding:10px 0;
align-self: flex-start;
${ media.mobile`
      width:100%;
  `}
`;
const PhonesImage = styled.img`
width: 44.3%;
padding-left: 20px;
align-self: flex-start;
`;
const MobileText = styled.p`
margin-top:10px;
`;

const MobilePromotion = styled.div`

display:flex;
flex-direction:row;
flex-grow:1;
overflow:hidden;
${ media.mobile`
      flex-direction:column;
  `}
`;

const AppButtonsWrapper = styled.div`
  display:flex;
  flex-direction:row;
  flex-grow:1;
  margin-top:15px;
  ${ media.mobile`
    flex-direction: column;
  `}
`;

const BadgeImage = styled.img`
max-height:50px;
height:100%;
${ media.mobile`
    max-width:153px;
    width: 100%;
  `}
`;

const MarginLeftLink = styled.a`
  margin-left: 35px;
  ${ media.mobile`
      margin-left: 0;
  `}
`;

const SingleOffer = (props) => {
  return(
    <ContentInner column>
      <ContentParagraph>Your balance available to spend is:</ContentParagraph>
      <AmountBox>
        <Amount>£{props.balance}</Amount>
      </AmountBox>
      <ContentInnerColumn column>
        <ContentColLeft>
            <ContentParagraph fontWeight={'bold'} marginBottom={'0'}>To start shopping, redeem your money online by clicking on any of the retailers below</ContentParagraph>
            <ContentParagraph maxWidth={'80%'} margin>You can also use your prepaid Mastercard at over 38 million locations worldwide</ContentParagraph>
            <Retailers>
            {props.retailers}
            </Retailers>
        </ContentColLeft>
        <ContentColRight>
        <ContentParagraph>Special offers</ContentParagraph>
        <TwoColumnWrapper>
          <SingleColumn>
           <RightPaddingDiv>
           <Offers>
            {props.offers}
            </Offers>
           </RightPaddingDiv>
            
          </SingleColumn>
          <SingleColumn>
              <Header1>Download the App</Header1>
              <Header2>You're good to go</Header2>
              <MobilePromotion>
                
                <TextWrapperDiv><p>As you’ve already created an account with us, simply download our free mobile app and log in using the email address and password you set.</p><MobileText>Once logged in, you’ll be able to keep track of your balance and get ideas on where to spend your card. If you have multiple cards from Edenred, you can add these too, allowing you to manage all of your accounts in once place.</MobileText></TextWrapperDiv>
                
                <PhonesImage src='https://cdn.edenred.uk.com/static/default/myedenredcards/promotions/image-1.png'/>
              </MobilePromotion>
              <AppButtonsWrapper>
            <a href="https://apps.apple.com/de/app/myedenred/id1443589821?ls=1" target="_blank"><BadgeImage src="https://cdn.edenred.uk.com/static/default/myedenredcards/promotions/badge-download-on-the-app-store.svg" /></a>
            <MarginLeftLink href="https://play.google.com/store/apps/details?id=com.edenred.eq.myedenred" target="_blank"><BadgeImage src="https://cdn.edenred.uk.com/static/default/myedenredcards/promotions/768px-Google_Play_Store_badge_EN.svg.png" /></MarginLeftLink>
          </AppButtonsWrapper>
          </SingleColumn>
          
        </TwoColumnWrapper>
          
         </ContentColRight>
      </ ContentInnerColumn>
    </ContentInner>
  );
}

export default SingleOffer;


// WEBPACK FOOTER //
// ./src/containers/BalancePage/SingleOfferApp.js